module.exports = __webpack_public_path__ + "img/project_7.97646c10.png";